import { FLOWCODE_COUNT_QUERY } from '@dtx-company/flow-codegen/src/code/queries'
import {
  FlowcodeCountQuery,
  FlowcodeCountQueryVariables
} from '@dtx-company/flow-codegen/src/code/generated.types'
import { flowcodeApi } from './init'

export const userQueries = flowcodeApi.injectEndpoints({
  endpoints: builder => ({
    flowcodeCount: builder.query<FlowcodeCountQuery, FlowcodeCountQueryVariables>({
      query: () => ({
        document: FLOWCODE_COUNT_QUERY,
        authOnly: true
      }),
      providesTags: ['flowcodeCount']
    })
  })
})

export const { useFlowcodeCountQuery } = userQueries
